import { gql } from '@urql/core';
import React from 'react';
import { useAppState } from '../../../../client/providers/AppProvider';
import {
    Content_File,
    Espin_Follow_Type_Enum,
    Espin_Game_Definition_Enum,
    FollowerCardFragment,
} from '../../../../generated/spin-graphql';
import { SocialCard, SocialCardData } from './SocialCard';

type Props = {
    follow: FollowerCardFragment;
    viewedAt: any;
};

gql`
    fragment FollowerCard on espin_follow {
        follow_type
        player_user {
            deleted_at
            player_profile {
                user_id
                first_name
                last_name
                slug
                graduating_class
                profile_image {
                    ...SpinContentImageDisplay
                }
                player_games {
                    primary

                    game {
                        name
                        game_definition
                    }
                }
            }
        }
        parent_user_id
        college_user_name
        college {
            name
            slug
            logo {
                ...SpinContentImageDisplay
            }
        }
        college_user {
            deleted_at
        }
        high_school_user {
            deleted_at
        }
        high_school {
            contact_name
            name
            slug
            profile_pic_file {
                ...SpinContentImageDisplay
            }
        }
    }
`;

export const FollowerCard: React.FC<Props> = ({ follow, viewedAt }) => {
    // let getPrimaryGame: Espin_Game_Definition_Enum | null;
    // let primaryGameName: string | null;
    const { subscribed } = useAppState();
    const followType = follow?.follow_type;
    let fullName: string = '',
        slug: string = '',
        profileImg: Partial<Content_File>,
        getPrimaryGame: Espin_Game_Definition_Enum | null,
        primaryGameName: string | null,
        hasGraduatingClass: boolean = false,
        graduatingYear: string,
        isParent: boolean = false,
        deletedUser: boolean = false,
        collegeName: string = '';
    if (followType === Espin_Follow_Type_Enum.PlayerFollowsCollege) {
        fullName =
            `${follow?.player_user?.player_profile?.first_name} ${follow?.player_user?.player_profile?.last_name}` ??
            'N/A';
        slug = `players/${follow?.player_user?.player_profile?.slug}`;
        profileImg = subscribed ? follow?.player_user?.player_profile?.profile_image : null;
        follow.player_user?.player_profile.player_games?.forEach((game) => {
            if (game.primary) {
                getPrimaryGame = game.game.game_definition;
                primaryGameName = game.game.name;
            }
        });
        hasGraduatingClass = true;
        graduatingYear = follow?.player_user?.player_profile?.graduating_class;
        if (follow?.parent_user_id) {
            isParent = true;
        }
        if (!!follow?.player_user?.deleted_at) {
            deletedUser = true;
        }
    } else if (followType === Espin_Follow_Type_Enum.CollegeFollowsPlayer) {
        fullName = follow?.college_user_name ?? 'N/A';
        slug = `colleges/${follow?.college?.slug}`;
        // `${follow?.player_user.player_profile.first_name} ${follow?.player_user.player_profile.last_name}` ?? 'N/A';
        profileImg = subscribed ? follow?.college?.logo : null;
        if (!!follow?.college_user?.deleted_at) {
            deletedUser = true;
        }
    } else if (followType === Espin_Follow_Type_Enum.CollegeFollowsHighSchool) {
        if (!!!follow?.college) {
            collegeName = 'Unverified College';
            fullName = '';
            profileImg = null;
            slug = `colleges/`;
        } else {
            collegeName = follow?.college.name;
            fullName = follow?.college_user_name ?? 'N/A';
            profileImg = subscribed ? follow?.college?.logo : null;
            slug = `colleges/${follow?.college?.slug}`;
            if (!!follow?.college_user?.deleted_at) {
                deletedUser = true;
            }
        }
    } else if (followType === Espin_Follow_Type_Enum.HighSchoolFollowsCollege) {
        if (!!!follow?.high_school) {
            collegeName = 'Unverified High School';
            fullName = '';
            profileImg = null;
            slug = `dashboard/`;
        } else {
            collegeName = follow?.high_school.name;
            fullName = follow?.high_school.contact_name ?? 'N/A';
            profileImg = subscribed ? follow?.high_school?.profile_pic_file : null;
            slug = `high-schools/${follow?.high_school?.slug}`;
            if (!!follow?.college_user?.deleted_at) {
                deletedUser = true;
            }
        }
    }

    const data: SocialCardData = {
        label: 'New Follower!',
        subLabel: fullName,
        picAltText: `${fullName}'s picture`,
        profileImg,
        slug: slug,
        unread: !viewedAt,
        getPrimaryGame,
        primaryGameName,
        hasGraduatingClass,
        graduatingYear,
        isParent,
        deletedUser,
        collegeName,
    };

    return (
        <>
            <SocialCard data={data} />
        </>
    );
};
